import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:flex sm:flex-row sm:flex-nowrap sm:items-center"
}
const _hoisted_2 = { class: "mb-20 sm:mb-0 sm:w-1/2 sm:pr-15 md:pr-20 xl:pr-30" }
const _hoisted_3 = { class: "sm:w-1/2 sm:px-15 md:px-20 xl:px-30" }
const _hoisted_4 = {
  key: 0,
  class: "o-text-caption not-italic uppercase block mb-5"
}
const _hoisted_5 = { class: "mb-20" }
const _hoisted_6 = { key: "street" }
const _hoisted_7 = {
  key: "zipcity",
  class: "mb-10"
}
const _hoisted_8 = { key: "phone" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: "email" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.store)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.image.url)
              ? (_openBlock(), _createBlock(_component_ResponsiveImage, {
                  key: 0,
                  "image-url": _ctx.image.url,
                  "aspect-ratio": { 'max-xs': 16/9, 'default': 4/3},
                  "width-on-screen": { 'sm': 50 },
                  "focus-points": _ctx.image.focusPoints,
                  focus: _ctx.image.focus,
                  zoom: _ctx.image.zoom,
                  alt: _ctx.store.name,
                  "bg-color": _ctx.image.hexCode,
                  flip: _ctx.image.flip,
                  "cache-bust": _ctx.image.cachebust
                }, null, 8, ["image-url", "focus-points", "focus", "zoom", "alt", "bg-color", "flip", "cache-bust"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.heading)
              ? (_openBlock(), _createElementBlock("em", _hoisted_4, _toDisplayString(_ctx.heading), 1))
              : _createCommentVNode("", true),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.store.name), 1),
            _createElementVNode("div", null, [
              (_ctx.store.street)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.store.street), 1))
                : _createCommentVNode("", true),
              (_ctx.store.zipCode || _ctx.store.city)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.store.zipCode) + " " + _toDisplayString(_ctx.store.city), 1))
                : _createCommentVNode("", true),
              (_ctx.store.phoneNumber)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    _createElementVNode("a", {
                      href: 'tel:' + _ctx.store.phoneNumber
                    }, _toDisplayString(_ctx.store.phoneNumber), 9, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.store.email)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createElementVNode("a", {
                      href: 'mailto:' + _ctx.store.email
                    }, _toDisplayString(_ctx.store.email), 9, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_12, [
                _renderSlot(_ctx.$slots, "default", { store: _ctx.store })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}